import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  idPrefix: string
  size?: number
}

export const LeftMessageIcon: FC<Props> = ({
  idPrefix,
  size = 24,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 12C21 7.03093 16.9711 3 12 3C7.02892 3 3 7.03093 3 12C3 16.9711 7.02892 21 12 21H20.0477V21C20.5688 21 20.4067 20.2612 20.1222 19.8246L19.2465 18.4807C19.004 18.1085 19.0409 17.6242 19.3011 17.2642C20.371 15.784 21 13.9661 21 12Z"
        fill={`url(#${idPrefix}paint0_linear_65643_164696)`}
        stroke={`url(#${idPrefix}paint1_linear_65643_164696)`}
        strokeWidth="1.4"
      />
      <path
        d="M13.8245 7.32084C13.9004 7.18213 14.0996 7.18213 14.1755 7.32084L15.0326 8.88795C15.0509 8.9215 15.0785 8.94909 15.1121 8.96745L16.6792 9.82453C16.8179 9.90039 16.8179 10.0996 16.6792 10.1755L15.1121 11.0326C15.0785 11.0509 15.0509 11.0785 15.0326 11.1121L14.1755 12.6792C14.0996 12.8179 13.9004 12.8179 13.8245 12.6792L12.9674 11.1121C12.9491 11.0785 12.9215 11.0509 12.8879 11.0326L11.3208 10.1755C11.1821 10.0996 11.1821 9.90039 11.3208 9.82453L12.8879 8.96745C12.9215 8.94909 12.9491 8.9215 12.9674 8.88795L13.8245 7.32084Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={idPrefix + 'paint0_linear_65643_164696'}
          x1="7.875"
          y1="6.75"
          x2="17.625"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9BAD" />
          <stop offset="0.5" stopColor="#EB4494" />
          <stop offset="1" stopColor="#C35065" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint1_linear_65643_164696'}
          x1="7.5"
          y1="4.5"
          x2="12"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEBED" />
          <stop offset="1" stopColor="#FFBBC3" />
        </linearGradient>
      </defs>
    </svg>
  )
}
